import React from 'react';
import { motion } from 'framer-motion';
import { FaTachometerAlt } from 'react-icons/fa';

const SpeedIndicator = ({ level }) => {
  const getSpeedLevel = () => {
    if (level >= 5) return { text: '光速', color: 'from-red-500 to-red-600', bars: 5 };
    if (level >= 4) return { text: '閃電', color: 'from-purple-500 to-purple-600', bars: 4 };
    if (level >= 3) return { text: '疾風', color: 'from-cyan-500 to-blue-500', bars: 3 };
    if (level >= 2) return { text: '衝刺', color: 'from-green-500 to-emerald-500', bars: 2 };
    return { text: '起步', color: 'from-blue-400 to-blue-500', bars: 1 };
  };

  const speedInfo = getSpeedLevel();

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      // 手機版在最上方置中,桌面版在右側
      className="fixed top-2 left-1/2 -translate-x-1/2 sm:top-20 sm:left-auto sm:right-4 sm:translate-x-0 z-50 pointer-events-none"
    >
      <div
        className={`
          bg-gradient-to-r ${speedInfo.color} text-white 
          px-2.5 py-1.5 sm:px-3 sm:py-2 
          rounded-lg sm:rounded-xl shadow-lg 
          flex items-center gap-1.5 sm:gap-2 
          border border-white/20 sm:border-2
        `}
      >
        <FaTachometerAlt className="text-white text-sm sm:text-lg opacity-80" />
        
        <div className="flex flex-col">
          <span className="text-[8px] sm:text-[10px] font-bold uppercase tracking-wide opacity-80 leading-tight">
            Lv.{level}
          </span>
          <span className="text-xs sm:text-sm font-black tracking-wide leading-tight">
            {speedInfo.text}
          </span>
        </div>

        <div className="flex gap-0.5 ml-1 sm:ml-2">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className={`
                w-1 h-3 sm:w-1.5 sm:h-4 rounded-full transition-all duration-300
                ${i < speedInfo.bars 
                  ? 'bg-white shadow-[0_0_5px_rgba(255,255,255,0.8)]' 
                  : 'bg-black/20'
                }
              `}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SpeedIndicator;